import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = () => {
  return (
    <div>
      <ToastContainer autoClose={5000}/>
    </div>
  );
};

export default Toast;


// WEBPACK FOOTER //
// ./src/components/util/Toast.js